import { useMutation } from '@apollo/client';

import {
  AnalyticsProxyMutation,
  AnalyticsProxyMutationVariables,
} from '../graphql/generated';
import { SEND_ANALYTICS } from '../graphql/mutations';

const useSendAnalytics = () => {
  const [sendAnalytics, result] = useMutation<
    AnalyticsProxyMutation,
    AnalyticsProxyMutationVariables
  >(SEND_ANALYTICS);

  return {
    sendAnalytics,
    ...result,
  };
};

export default useSendAnalytics;
